import BaseEvent, { BaseGetEvent, IBaseEvent } from './BaseEvent';

export interface ISelectEvent extends IBaseEvent {
  type: 'select';
  toJSON(): BaseGetEvent & {
    type: ISelectEvent['type'];
    value: string | number;
  };
}

export default class SelectEvent extends BaseEvent implements ISelectEvent {
  type = 'select' as const;

  private value: string | number;
  private inputPlaceholder: string | undefined;

  constructor({
    description,
    inputPlaceholder,
    value,
  }: {
    description: string | undefined;
    inputPlaceholder?: string;
    value: string | number;
  }) {
    super(description);
    this.value = value;
    this.inputPlaceholder = inputPlaceholder;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      type: this.type,
      description: this.description,
      value: this.value,
      inputPlaceholder: this.inputPlaceholder,
    };
  }
}
